export default __webpack_public_path__ + "static/media/home_icon.86ea2b65.svg";